import { TooltipFilled } from '@icon';
import classNames from 'classnames';
import React from 'react';
import { useTheme } from 'styled-components';
import Tooltip from '../../../tooltip';
import { useDescriptionsContext } from '../../descriptions.context';
import { descriptionsClasses } from '../../descriptions.styled';
import { TDescriptionsVariant } from '../../descriptions.types';

interface DescriptionsLabelProps {
  children: React.ReactNode;
  tooltip?: React.ReactNode;
}

interface TriggerElementProps
  extends React.DetailedHTMLProps<React.SVGAttributes<SVGSVGElement>, SVGSVGElement> {
  isOpen?: boolean;
  variant?: TDescriptionsVariant;
}

const TriggerElement: React.FunctionComponent<TriggerElementProps> = (props) => {
  const { isOpen, variant, ...rest } = props;
  const theme = useTheme();
  const iconColor =
    props.variant === 'on-dark' ? theme.color.tint.tertiaryDark : theme.color.tint.tertiary;

  return (
    <TooltipFilled
      {...rest}
      width={16}
      height={16}
      color={
        isOpen
          ? theme.createOverlayColor(iconColor, 'active', variant === 'on-dark' ? 'dark' : 'light')
          : iconColor
      }
      className={classNames(descriptionsClasses.labelItemIcon, variant)}
    />
  );
};

const DescriptionsLabel: React.FunctionComponent<DescriptionsLabelProps> = ({
  children,
  tooltip,
}) => {
  const context = useDescriptionsContext();

  return (
    <span className={descriptionsClasses.labelItem}>
      {children}
      {tooltip ? (
        <Tooltip trigger={['click']} placement={'top'} variant="large" content={tooltip}>
          <TriggerElement variant={context.variant} />
        </Tooltip>
      ) : null}
    </span>
  );
};

export default DescriptionsLabel;
